import React from "react"
import styled from "styled-components"
import { toRem } from "../../../utils/styles-function"

export interface HeaderNumberProps {
  number: string | number
  numberText: string | React.ReactNode
}

const HeaderNumberContainer = styled.div`
  @media screen and (min-width: 1024px) {
    display: block;
  }
  @media screen and (max-width: 1023px) {
    display: none;
  }
  font-style: normal;
  font-weight: normal;
`

const HeaderNumberStyles = styled.div`
  font-family: "SB Sans Interface", serif;
  font-size: ${toRem(13)};
  line-height: ${toRem(15)};
  font-feature-settings: "pnum" on, "lnum" on;
  color: #333f48;
`

const HeaderNumberTextStyles = styled.div`
  font-family: SB Sans Interface, serif;
  font-size: ${toRem(12)};
  line-height: ${toRem(14)};
  font-feature-settings: "pnum" on, "lnum" on;
  color: #878b90;
`

export const HeaderNumber: React.FC<HeaderNumberProps> = ({
  number,
  numberText,
}) => {
  return (
    <HeaderNumberContainer>
      <HeaderNumberStyles>{number}</HeaderNumberStyles>
      <HeaderNumberTextStyles>{numberText}</HeaderNumberTextStyles>
    </HeaderNumberContainer>
  )
}
